import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/images/trex_party.jpg'


const _hoisted_1 = { class: "app" }
const _hoisted_2 = {
  key: 0,
  class: "auth"
}
const _hoisted_3 = {
  key: 1,
  class: "container"
}
const _hoisted_4 = { class: "side-by-side" }
const _hoisted_5 = { class: "greeting" }
const _hoisted_6 = { class: "blue" }
const _hoisted_7 = { class: "prompt" }
const _hoisted_8 = {
  class: "prompts",
  id: "prompts"
}
const _hoisted_9 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_10 = {
  key: 1,
  class: "error"
}
const _hoisted_11 = {
  key: 2,
  class: "tabs-panel"
}
const _hoisted_12 = {
  key: 0,
  class: "history-container"
}
const _hoisted_13 = { class: "prompt-description" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "names green"
}
const _hoisted_17 = {
  key: 2,
  class: "history-container"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "modal-content" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "modal-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuthSupa = _resolveComponent("AuthSupa")!
  const _component_HeaderBar = _resolveComponent("HeaderBar")!
  const _component_PromptForm = _resolveComponent("PromptForm")!
  const _component_ExploreTab = _resolveComponent("ExploreTab")!
  const _component_HowToPanel = _resolveComponent("HowToPanel")!
  const _component_ContactPanel = _resolveComponent("ContactPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.session)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_AuthSupa)
        ]))
      : _createCommentVNode("", true),
    (_ctx.session)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_component_HeaderBar, { user: _ctx.user }, null, 8, ["user"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "title" }, [
                _createElementVNode("span", { class: "blue" }, "Hello")
              ], -1)),
              _cache[9] || (_cache[9] = _createTextVNode()),
              _createElementVNode("h4", null, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.username), 1)
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("p", { class: "subtitle" }, "welcome to coloring AI, let's create drawings.", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "app-image" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "app-image",
                  class: "app-image-img"
                })
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "subtitle" }, [
                _createTextVNode("On the right is your AI prompt form "),
                _createElementVNode("br"),
                _createTextVNode(" below is where the magic will be saved.")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_PromptForm, { onRefreshNeeded: _ctx.refreshPrompts }, null, 8, ["onRefreshNeeded"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[13] || (_cache[13] = [
                  _createElementVNode("div", { class: "loading-spinner" }, null, -1),
                  _createElementVNode("p", { class: "loading-text" }, "Working, hold on...", -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectTab('pages'))),
                    class: _normalizeClass(["tab-button", { active: _ctx.showPages }])
                  }, "My pages", 2),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTab('explore'))),
                    class: _normalizeClass(["tab-button", { active: _ctx.showExplore }])
                  }, "Explore", 2)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showExplore)
              ? (_openBlock(), _createBlock(_component_ExploreTab, { key: 3 }))
              : _createCommentVNode("", true),
            (_ctx.showPages)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prompts, (prompt) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: prompt.id,
                            class: "prompt-item"
                          }, [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(prompt.prompt), 1),
                            _createElementVNode("img", {
                              src: prompt.image_url,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal($event))),
                              alt: "prompt image",
                              class: "prompt-image"
                            }, null, 8, _hoisted_14),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.goToColoring(prompt)),
                              class: "color-btn"
                            }, "🎨", 8, _hoisted_15)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[14] || (_cache[14] = [
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, "Drawings")
                        ], -1)
                      ])))
                    : _createCommentVNode("", true),
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawings, (drawing) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: drawing.id,
                            class: "prompt-item"
                          }, [
                            _createElementVNode("img", {
                              src: drawing.drawing_url,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal($event))),
                              alt: "drawing image",
                              class: "prompt-image"
                            }, null, 8, _hoisted_18),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.goToColoring(drawing)),
                              class: "drawing-btn"
                            }, "🎨", 8, _hoisted_19),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.delDrawing(drawing.uuid)),
                              class: "drawing-btn"
                            }, "❌", 8, _hoisted_20)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createVNode(_component_HowToPanel)
              ]),
              _createVNode(_component_ContactPanel)
            ])
          ]),
          (_ctx.isModalOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "modal-overlay",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("img", {
                    src: _ctx.selectedImage || undefined,
                    alt: "Full size image",
                    class: "modal-image"
                  }, null, 8, _hoisted_22),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.printImage && _ctx.printImage(...args))),
                      class: "print-btn"
                    }, "Print"),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args))),
                      class: "delete-btn"
                    }, "Delete"),
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                      class: "close-btn"
                    }, "Close")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}